module.exports = __webpack_public_path__ + "img/15575639623563564322.3523604e.png";